import axios from "axios";
import FileSaver from 'file-saver';
import useStore from '../../_global/jsx/store.js';


const customHeader = 'SIRA Worker or contractor tool results page';
const matrixData = useStore.getState().matrixData;

export const getHtmlForPDF = () => {
    let pageHtml = document.getElementById('decisionTree__app-wrapper').innerHTML;
    pageHtml = pageHtml.replaceAll("'", "&#39;" );
    return pageHtml;
}

export const getPdfUrl = (html) => {
  const cssFile = matrixData['printStylesUrl'];
  return new Promise((resolve, reject)=> {
    if(!html){
      reject('No html supplied');
      return;
    }
    var pdfLinkConfig = {
      method: 'post',
      // url: 'https://mycorsnewcasio.herokuapp.com/https://api.printfriendly.com/v2/pdf/create?api_key=767663207fe1eef6c6ef49d240d5d927',
      url: 'https://api.printfriendly.com/v2/pdf/create?api_key=767663207fe1eef6c6ef49d240d5d927',
      headers: { 
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        'Accept': 'application/pdf'
      },
      data : `html=${encodeURIComponent(html)}&css_url=${cssFile}&header_text=${customHeader}&header_image_url=https://www.sira.nsw.gov.au/__data/assets/file/0006/1136805/NSWGov_Logo_RGB_Primary_FullColour.svg`
    };
    resolve(axios(pdfLinkConfig));
    
  })
}
  
  export const downloadPDF = (link) => {
    FileSaver.saveAs(link, "Worker or contractor tool results page.pdf");
  }



/* Send PDF as email */
const getBlobFromPDFUrl = (email, url) => {

  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
        //now convert your Blob from the response into a File and give it a name
        var fileOfBlob = new File([this.response], 'summary.pdf');

        // Now do something with the File
        buildAndSendRequest(email, fileOfBlob)
    }
  }
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();  
}

const buildAndSendRequest = (email, data) => {

  var submissionDetails = new Blob([data], { type: "application/pdf"});
  var fileOfBlob = new File([submissionDetails], 'Worker or contractor tool results page.pdf');
  
  const matrixFormAssetForEmail = matrixData.emailAssetUrl;

  let formData = new FormData();
  formData.append('SQ_FORM_1086620_PAGE', 1)
  formData.append('q1086620:q1', email);
  formData.append('q1086620:q2', fileOfBlob);
  formData.append("form_email_1086620_submit", 'submit');


  var request = new XMLHttpRequest();
  request.open("POST", matrixFormAssetForEmail);
  request.send(formData);
}


export const prepPdfForEmail = (emailAddress, link) => {
  getBlobFromPDFUrl(emailAddress, link);
}


/* make options sentence case.  options-buttons.jsx */
export function capitalizeFirstLetter(string) {
 return string.charAt(0).toUpperCase() + string.slice(1);
}


/* email-pdf.jsx */
export function validateEmail (email) {
 const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 return re.test(String(email).toLowerCase());
}


/* TESTS for loading assets into Matrix */
export function checkSummaryPages (matrixData){
    // these are pages that have no child pages, and are not page_type "Summary" 
    // if the page has no children, it should be a summary page
    let query = [];

    let pagesObject = matrixData['pages'];
    for (const page in pagesObject){
      let childPages = pagesObject[page]['children'] ? true : false;
      let pageType = pagesObject[page]['page_type'];
      if (!childPages && pageType !== "Summary"){
        query.push(page)
      }
    }
    console.log(`the following pagess have no children, AND are not summary pages ${query}`);
}

export function checkIfAssetHasOneChild (matrixData) {
  // check if a page has children key AND only has 1 child in its children array
  // ok if 2+ (question)  
  let singleChildrenPages = [];

  let allPages = matrixData['pages'];
  for (const page in allPages){
    let children = allPages[page]['children'];
    if(children && children.length == 1){
      singleChildrenPages.push(page)
    }
  }  
  console.log(`The following pages have only 1 child ${singleChildrenPages}`);
}

export function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}


export function readyAccordions() {
    var mqListener = function (varObj) {
      $(window).on('breakpoint-change', function (e, breakpoint) {
        varObj.breakpoint = breakpoint;
      });
    };

    let sqEasing = [0.77, 0, 0.175, 1]

    var initAccordion = function (varObj) {
      varObj.$accordion.each(function () {
        var $this = $(this),
          $thisBtn = $this.find('.accordion__btn'),
          $thisBtnTarget = $($thisBtn.attr('href'));
        var thisBtnTarget = $thisBtnTarget.attr('id');

        // assign ARIA attr
        $thisBtn.attr({
          'aria-expanded': false,
          'aria-controls': thisBtnTarget,
        });
        $thisBtnTarget.attr({
          'aria-hidden': false,
        });

        // hide content
        if (!$this.hasClass('is-accordion-active')) {
          $thisBtnTarget.hide();
        }
      });
    };

    var doAccordion = function (varObj) {
      varObj.$accordionBtn.on('click', function (e) {
        e.preventDefault();
        if (
          !(
            varObj.breakpoint === 'mq-large' &&
            varObj.$accordionBtn.hasClass('submissions__btn')
          )
        ) {
          var $this = $(this),
            $thisBtnTarget = $($this.attr('href')),
            $thisBox = $this.closest('.accordion__box'),
            $thisAccordion = $this.closest('.accordion');

          // close other accordion panels
          var $items = $(this)
            .closest('.accordion')
            .find('.accordion__box');

          $.each($items, function (index, item) {
            item = $(item);

            var id = item.find('.accordion__btn').attr('href');
            var thisId = $thisBox.find('.accordion__btn').attr('href');
          });

          if (!$thisAccordion.hasClass('is-no-active')) {
            if ($thisBox.hasClass('is-accordion-active')) {
              // hide content
              $thisBtnTarget.velocity('slideUp', sqEasing);
            } else {
              // show content
              $thisBtnTarget.velocity('slideDown', sqEasing);
            }

            $thisBox.toggleClass('is-accordion-active');
          }
        }
      });
    };

    function init() {
      var varObj = {
        $accordion: $('#decisionTree__app-wrapper .accordion__box'),
        $accordionBtn: $('#decisionTree__app-wrapper .accordion__btn'),
        breakpoint: '',
      };

      mqListener(varObj);
      initAccordion(varObj);
      doAccordion(varObj);
    }

    init();
}